import React, {useEffect, useState} from 'react'
import TableComponent from '../../../../components/Tables/TableComponent/TableComponent'
import PenEdit from '../../../../media/felsv/PenEdit.svg'
import MinusDelete from '../../../../media/felsv/MinusDelete.svg'
import {convertirNumeroConComas} from '../../../../utils/numbers.utils'

const TablaFacturacion = (props: any) => {
  const [rows, setRows] = useState([])

  useEffect(() => {
    const productos = props.rows.map((p: any, i: number) => ({
      ...p,
      index: i,
      cantidadNew: convertirNumeroConComas(p.cantidad),
      precioNew: `$${convertirNumeroConComas(p.precio)}`,
      cantidadDescuentoNew: `$${convertirNumeroConComas(p.cantidadDescuento)}`,
      subtotalNew: `$${
        props.idDoc === '01'
          ? convertirNumeroConComas(p.total)
          : convertirNumeroConComas(p.subtotal)
      }`,
    }))
    setRows(productos)
  }, [props.rows, props.idDoc])

  const acciones = (item: any) => {
    const editar = () => {
      props.openModalEditar(item.index, item)
    }
    const eliminar = () => {
      props.openModalEliminar(item.index)
    }
    return (
      <>
        <button className='table-action' onClick={editar}>
          <img src={PenEdit} alt='Edit' className='table-img-action' />
        </button>
        <button className='table-action' onClick={eliminar}>
          <img src={MinusDelete} alt='Edit' className='table-img-action' />
        </button>
      </>
    )
  }

  const headCells = [
    {
      id: 'cantidadNew',
      indexData: 'cantidadNew',
      label: 'Cantidad',
      disablePadding: false,
      sort: false,
    },
    {
      id: 'descripcion',
      indexData: 'descripcion',
      label: 'Descripción',
      disablePadding: false,
      sort: false,
    },
    {
      id: 'precioNew',
      indexData: 'precioNew',
      label: props.idDoc === '01' ? 'Precio con IVA' : 'Precio unitario',
      disablePadding: false,
      sort: false,
    },
    {
      id: 'cantidadDescuentoNew',
      indexData: 'cantidadDescuentoNew',
      label: 'Descuento por item',
      disablePadding: false,
      sort: false,
    },
    {
      id: 'subtotalNew',
      indexData: 'subtotalNew',
      label: 'Ventas gravadas',
      disablePadding: false,
      sort: false,
    },
    {
      id: 'acciones',
      indexData: 'acciones',
      label: 'Acciones',
      disablePadding: false,
      sort: false,
      render: acciones,
    },
  ]

  if (props?.sinAcciones === true) headCells.pop()

  return (
    <>
      <TableComponent headCells={headCells} rows={rows} align='center' minWidth='800px' />
      <div style={{width: '100%'}}>
        <div className='container-fact-row'>
          <div className='container-fact-col-12 w-100'>
            <table className='w-100'>
              <tbody>
                <tr>
                  <td className='label-column-fact align-end'>
                    <div className='div-calculo-p-black' style={{marginRight: '3%'}}>
                      Subtotal
                    </div>
                  </td>
                  <td className='total-column-fact align-end'>
                    <div className='div-calculo-p-black'>
                      ${convertirNumeroConComas(props?.datos?.subtotal) ?? '0.00'}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className='label-column-fact align-end'>
                    <div className='div-calculo-p-black' style={{marginRight: '3%'}}>
                      Descuento
                    </div>
                  </td>
                  <td className='total-column-fact align-end'>
                    <div className='div-calculo-p-red'>
                      ${convertirNumeroConComas(props?.datos?.descuento) ?? '0.00'}
                    </div>
                  </td>
                </tr>
                {props.idDoc !== '01' && (
                  <tr>
                    <td className='label-column-fact align-end'>
                      <div className='div-calculo-p-black' style={{marginRight: '3%'}}>
                        Impuesto al valor agregado 13%
                      </div>
                    </td>
                    <td className='total-column-fact align-end'>
                      <div className='div-calculo-p-black'>
                        ${convertirNumeroConComas(props?.datos?.totalImpuesto1) ?? '0.00'}
                      </div>
                    </td>
                  </tr>
                )}
                {(props.idDoc !== '01' || props.checkContribuyente === true) && (
                  <tr>
                    <td className='label-column-fact align-end'>
                      <div className='div-calculo-p-black' style={{marginRight: '3%'}}>
                        Retención 1%
                      </div>
                    </td>
                    <td className='total-column-fact align-end'>
                      <div className='div-calculo-p-red'>
                        ${convertirNumeroConComas(props?.datos?.totalImpuesto2) ?? '0.00'}
                      </div>
                    </td>
                  </tr>
                )}
                <tr>
                  <td className='label-column-fact align-end'>
                    <div className='div-calculo-p-black' style={{marginRight: '3%'}}>
                      Total
                    </div>
                  </td>
                  <td className='total-column-fact align-end'>
                    <div className='div-calculo-p-secondary'>
                      ${convertirNumeroConComas(props?.datos?.totalConRetecion) ?? '0.00'}
                    </div>
                  </td>
                </tr>
                {
                  (props?.datos?.totalDocRelacionado) &&
                  (
                    <tr style={{opacity: '50%'}}>
                      <td className='label-column-fact align-end'>
                        <div className='div-calculo-p-black' style={{marginRight: '3%'}}>
                          Total original (CCF)
                        </div>
                      </td>
                      <td className='total-column-fact align-end'>
                        <div className='div-calculo-p-black'>
                          ${convertirNumeroConComas(props?.datos?.totalDocRelacionado) ?? '0.00'}
                        </div>
                      </td>
                    </tr>
                  )
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  )
}

export default TablaFacturacion
